"use client";

import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";

import "./SummaryPopup.css";

export default function SummaryPopup({ onConfirm, onClose, summaries,selectedType,setSelectedType }) {

  const handleConfirm = () => {
    onConfirm(selectedType);
  };

  return (
    <div className="summary-popup-overlay">
      <div className="summary-popup">
        <div className="summary-popup-header">
          <h2>
            Summary options{" "}
            <span className="select-text">(Select one option)</span>
          </h2>
        </div>

        <div className="summary-type-selector">
          <div className="buttons-container">
            <button
              className={`type-button ${
                selectedType === "0" ? "active" : ""
              }`}
              onClick={() => setSelectedType("0")}
            >
              Summary 1
            </button>
            <button
              className={`type-button ${
                selectedType === "1" ? "active" : ""
              }`}
              onClick={() => setSelectedType("1")}
            >
              Summary 2
            </button>
            <button
              className={`type-button ${
                selectedType === "2" ? "active" : ""
              }`}
              onClick={() => setSelectedType("2")}
            >
              SOAP Notes
            </button>
          </div>
        </div>

        <div className="summary-content">
          <Markdown remarkPlugins={[remarkGfm]}>
            {summaries[selectedType]}
          </Markdown>
        </div>

        <div className="summary-popup-footer">
          <button className="confirm-button" onClick={handleConfirm}>
            Confirm summary
          </button>
        </div>
      </div>
    </div>
  );
}
